import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('anthropic'),
  titleToNamespace: true,
  avatarPath: avatars.anthropic,
  logoPath: logos.anthropic
});
